import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  thu_tu: undefined, // optional - Thứ tự sắp xếp
  uu_tien: undefined, // required - Đây có phải là bài viết được ưu tiên
  tieu_de: undefined, // required - Tiêu đề bài viết
  mo_ta_ngan_gon: undefined, // optional - Giá trị
  anh_id: undefined, // optional, ref: mushroom_file - Ảnh bài viết
  noi_dung: undefined, // optional - Giá trị
  tags: [], // optional - Tags của bài viết
  bai_viet_ids: [], // optional - Các bài viết liên quan
  hien_thi: undefined, // required - Hiển thị
  thoi_diem_tao: undefined, // required - Thời điểm tạo
  but_danh: undefined, // optional - Bút danh/tác giả
  nguoi_tao_id: undefined, // required, ref: mushroom_user - Mã người tạo
};

model.thuTu = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 }
];

model.chuyenMuc = [
  {
    value: "Chuyên mục chung",
    label: "Chuyên mục chung",
  },
];

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkSpaceString], // required Tên chi nhánh
  company_id: [ValidService.required], // required Mã công ty
  value: [ValidService.required], // required Giá trị hệ số
  code: [ValidService.required, ValidService.checkSpaceString], // required
  type: [ValidService.required, ValidService.checkSpaceString, ValidService.requiredChange],
  disabled: [], // required Đã bị khóa chưa
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      tieu_de: "",
      thoi_diem_tao: "",
    },
    valid: {
      thu_tu: [],
      thoi_diem_tao: []
    },
    operator: {
      tieu_de: ":regex_i:",
      thoi_diem_tao: ":in_that_day:",
    },
  },
};

export default model;
